import {useState} from "react";

import {Modal} from "@pg-design/modal-module";

import {usePreventContextDefaultOnClose} from "../hooks/use_prevent_context_default_on_close";
import {usePrompt} from "../hooks/use_prompt";
import {PromptInput} from "./PromptInput";

export const Prompt = () => {
    const {_internalContext} = usePrompt();
    const context = usePreventContextDefaultOnClose(_internalContext);
    const [inputValue, setInputValue] = useState<string | number | undefined>();

    const onAfterOpen = () => {
        setInputValue(context.input?.value || "");
    };

    const onCancelClick = () => {
        context.promptPromiseReject?.();
        context.setPromptParamsWithDefaults?.({isPromptOpen: false});
    };

    const onOkClick = () => {
        context.promptPromiseResolve?.(context.input ? {value: inputValue ?? ""} : {value: ""});
        context.setPromptParamsWithDefaults?.({isPromptOpen: false});
    };

    return (
        <Modal isOpen={_internalContext.isPromptOpen} onAfterOpen={onAfterOpen} onModalClose={onCancelClick} borderRadius={2} shouldCloseOnOverlayClick={false}>
            <Modal.Layout.Prompt
                onCancelClick={onCancelClick}
                onOkClick={onOkClick}
                header={context.text}
                okButtonText={context.okButtonText}
                cancelButtonText={context.cancelButtonText}
            >
                {context.input ? <PromptInput {...context.input} value={inputValue} onChange={setInputValue} /> : null}
            </Modal.Layout.Prompt>
        </Modal>
    );
};
import {useState} from "react";

import {Modal} from "@pg-design/modal-module";

import {usePreventContextDefaultOnClose} from "../hooks/use_prevent_context_default_on_close";
import {usePrompt} from "../hooks/use_prompt";
import {PromptInput} from "./PromptInput";

export const Prompt = () => {
    const {_internalContext} = usePrompt();
    const context = usePreventContextDefaultOnClose(_internalContext);
    const [inputValue, setInputValue] = useState<string | number | undefined>();

    const onAfterOpen = () => {
        setInputValue(context.input?.value || "");
    };

    const onCancelClick = () => {
        context.promptPromiseReject?.();
        context.setPromptParamsWithDefaults?.({isPromptOpen: false});
    };

    const onOkClick = () => {
        context.promptPromiseResolve?.(context.input ? {value: inputValue ?? ""} : {value: ""});
        context.setPromptParamsWithDefaults?.({isPromptOpen: false});
    };

    return (
        <Modal isOpen={_internalContext.isPromptOpen} onAfterOpen={onAfterOpen} onModalClose={onCancelClick} borderRadius={2} shouldCloseOnOverlayClick={false}>
            <Modal.Layout.Prompt
                onCancelClick={onCancelClick}
                onOkClick={onOkClick}
                header={context.text}
                okButtonText={context.okButtonText}
                cancelButtonText={context.cancelButtonText}
            >
                {context.input ? <PromptInput {...context.input} value={inputValue} onChange={setInputValue} /> : null}
            </Modal.Layout.Prompt>
        </Modal>
    );
};
